
routes.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider'];

export default function routes($stateProvider, $urlRouterProvider, $locationProvider) {
	$locationProvider.html5Mode(true);
	//$urlRouterProvider.otherwise('/');

  	$stateProvider
    .state('app.users', {
            abstract: false,
            url: '/admin-panel/usuarios',
            template: require('./users/list/userList.html'),
            controller: 'userListController',
            controllerAs:'userList'
	})
	.state('app.userCreate', {
		abstract: false,
		url: '/admin-panel/usuarios/crear',
		template: require('./users/create/userCreate.html'),
		controller: 'userCreateController',
		controllerAs:'userCreate'
	})
    .state('app.userEdit', {
            abstract: false,
            url: '/admin-panel/usuarios/edit?id',
            template: require('./users/edit/userEdit.html'),
            controller: 'userEditController',
            controllerAs:'userEdit'
      })
	.state('app.roles', {
		abstract: false,
		url: '/admin-panel/roles',
		template: require('./roles/list/rolesList.html'),
		controller: 'rolesListController',
		controllerAs:'rolesList'
	})
	.state('app.rolesCreate', {
		abstract: false,
		url: '/admin-panel/roles/crear',
		template: require('./roles/create/rolesCreate.html'),
		controller: 'rolesCreateController',
		controllerAs:'rolesCreate'
	})
	.state('app.modules', {
		abstract: false,
		url: '/admin-panel/modules',
		template: require('./permissions/modules/modulesList.html'),
		controller: 'modulesListController',
		controllerAs:'modulesList'
	})
	.state('app.levels', {
		abstract: false,
		url: '/admin-panel/levels',
		template: require('./levels/list/levelsList.html'),
		controller: 'levelsListController',
		controllerAs:'levelsList'
	})
	.state('app.levelsCreate', {
		abstract: false,
		url: '/admin-panel/levels/crear',
		template: require('./levels/create/levelsCreate.html'),
		controller: 'levelsCreateController',
		controllerAs:'levelsCreate'
	})
	.state('app.ambits', {
		abstract: false,
		url: '/admin-panel/ambits',
		template: require('./ambits/list/ambitsList.html'),
		controller: 'ambitsListController',
		controllerAs:'ambitsList'
	})
	.state('app.ambitsCreate', {
		abstract: false,
		url: '/admin-panel/ambits/crear',
		template: require('./ambits/create/ambitsCreate.html'),
		controller: 'ambitsCreateController',
		controllerAs:'ambitsCreate'
	})
	.state('app.cores', {
		abstract: false,
		url: '/admin-panel/cores',
		template: require('./cores/list/coresList.html'),
		controller: 'coresListController',
		controllerAs:'coresList'
	})
	.state('app.coresCreate', {
		abstract: false,
		url: '/admin-panel/cores/crear',
		template: require('./cores/create/coresCreate.html'),
		controller: 'coresCreateController',
		controllerAs:'coresCreate'
	})
	.state('app.learningObjetives', {
		abstract: false,
		url: '/admin-panel/learningObjetives',
		template: require('./learningObjetives/list/learningObjetivesList.html'),
		controller: 'learningObjetivesListController',
		controllerAs:'learningObjetivesList'
	})
	.state('app.learningObjetivesCreate', {
		abstract: false,
		url: '/admin-panel/learningObjetives/crear',
		template: require('./learningObjetives/create/learningObjetivesCreate.html'),
		controller: 'learningObjetivesCreateController',
		controllerAs:'learningObjetivesCreate'
	})
	.state('app.indicators', {
		abstract: false,
		url: '/admin-panel/indicators',
		template: require('./indicators/list/indicatorsList.html'),
		controller: 'indicatorsListController',
		controllerAs:'indicatorsList'
	})
	.state('app.indicatorsCreate', {
		abstract: false,
		url: '/admin-panel/indicators/crear',
		template: require('./indicators/create/indicatorsCreate.html'),
		controller: 'indicatorsCreateController',
		controllerAs:'indicatorsCreate'
	})
	.state('app.students', {
		abstract: false,
		url: '/admin-panel/students',
		template: require('./students/list/studentsList.html'),
		controller: 'studentsListController',
		controllerAs:'studentsList'
	})
	.state('app.studentsCreate', {
		abstract: false,
		url: '/admin-panel/students/crear',
		template: require('./students/create/studentsCreate.html'),
		controller: 'studentsCreateController',
		controllerAs:'studentsCreate'
	})
	.state('app.enabledIndicators', {
		abstract: false,
		url: '/admin-panel/enabledIndicators',
		template: require('./enabledIndicators/list/enabledIndicatorsList.html'),
		controller: 'enabledIndicatorsListController',
		controllerAs:'enabledIndicatorsList'
	})
	.state('app.enabledStudents', {
		abstract: false,
		url: '/admin-panel/enabledStudents',
		template: require('./enabledStudents/list/enabledStudentsList.html'),
		controller: 'enabledStudentsListController',
		controllerAs:'enabledStudents'
	})
	.state('app.educators', {
		abstract: false,
		url: '/admin-panel/educators',
		template: require('./educators/list/educatorsList.html'),
		controller: 'educatorsListController',
		controllerAs:'educatorsList'
	})
	.state('app.educatorsCreate', {
		abstract: false,
		url: '/admin-panel/educators/crear',
		template: require('./educators/create/educatorsCreate.html'),
		controller: 'educatorsCreateController',
		controllerAs:'educatorsCreate'
	})
	.state('app.enabledEducators', {
		abstract: false,
		url: '/admin-panel/enabledEducators',
		template: require('./enabledEducators/list/enabledEducatorsList.html'),
		controller: 'enabledEducatorsListController',
		controllerAs:'enabledEducatorsList'
	})
}



// WEBPACK FOOTER //
// ./src/app/admin-panel/adminPanel.route.js